import React from "react";
const PageBreak = () => {
    return (
        <div className={"pageBreaker"}></div>
    )
}

export default PageBreak;